export const encodeURL = (url) => url.replace(/\s/g, '_').replace(/\?/g, '');
